import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { PlaybackService, TimelineService } from '@splixer/player';
import { Pv2MixListComponent } from '../../content';
import { Pv2CurrentMixComponent } from '../current-mix/current-mix.component';
import { Pv2SegmentTimelineComponent } from '../timelines/segment-timeline.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'pv2-now-playing-page',
  templateUrl: 'now-playing-page.component.html',
  styleUrl: 'now-playing-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    Pv2MixListComponent,
    Pv2CurrentMixComponent,
    Pv2SegmentTimelineComponent,
    RouterLink,
  ],
})
export class Pv2NowPlayingPageComponent {
  public displayRelatedMixes = input(true);
  public displayPlaylists = input(true);
  public displayRandomContent = input(false);

  protected playbackService = inject(PlaybackService);
  protected timeline = inject(TimelineService);
}
